import { createCookie, readCookie } from './helpers/read-write-cookies';

// Handles animated icon switching for favouriting and reading from / writing to cookies
window.addEventListener('load', event => {
    let ogAnimationFill = document.getElementById('animated-icon-heart-fill');
    let ogAnimationDeplete = document.getElementById('animated-icon-heart-deplete');
    let elevationsPanels = document.querySelectorAll('.elevations-panel');
    let favouriteCookies = readCookie('favourite_elevations');
    let favouriteCookiesMap = (readCookie('favourite_elevations') ?? '').toLowerCase().split(',').map((ele) => ele.trim());
    let savedElevationsPanel = document.getElementById('savedElevationsPanel');
    let savedElevationsCount = 0;
    let windowHash = null;

    if (window.location.hash) {
        windowHash = window.location.hash.substring(1);
    }

    for (let panel of elevationsPanels) {
        let favoriteButtons = panel.querySelectorAll('.elevation-favourite-icon');
        let shareButtons = panel.querySelectorAll('.elevation-share-icon');
        let elevationCards = panel.querySelectorAll('.elevation-card');

        // highlights shared card
        for (let card of elevationCards) {
            let cardId = card.id;
            if (cardId === windowHash) {
                card.classList.add('animate-highlighted-elevation');
                card.classList.remove('shadow-lg');
            }
        }

        // share / url copy funcs
        for (let button of shareButtons) {
            let lock = 0;
            button.addEventListener('click', () => {
                if (!lock) {
                    lock = 1;
                    let shareInput = button.closest('.elevation-share-container').querySelector('.elevation-share-value-input');
                    let ogShareValue = shareInput.value;
                    let ogShareText = shareInput.dataset.shareText;
                    let mobileCopiedText = button.closest('.elevation-card').querySelector('.elevation-share-copy-text');

                    const shareData = {
                        title: 'Venture In',
                        text: ogShareText,
                        url: ogShareValue
                    };

                    if (navigator.canShare) {
                        navigator.share(shareData);
                        lock = 0;
                    } else {
                        // desktop funcs
                        navigator.clipboard.writeText(ogShareValue);
                        shareInput.value = 'Copied URL!';
                        setTimeout(() => {
                            shareInput.value = ogShareValue;
                            lock = 0;
                        }, 1100);

                        // mobile funcs
                        mobileCopiedText.classList.add('duration-1000');
                        mobileCopiedText.querySelector('p').classList.add('!opacity-100');
                        mobileCopiedText.classList.add('!-top-12');

                        setTimeout(() => {
                            mobileCopiedText.querySelector('p').classList.remove('!opacity-100');
                        }, 500);

                        setTimeout(() => {
                            mobileCopiedText.classList.remove('!-top-12');
                            mobileCopiedText.classList.remove('duration-1000');
                        }, 1000);
                    }
                }

            });
        }

        // counts favourite cards
        for (let button of favoriteButtons) {
            if (savedElevationsPanel && favouriteCookiesMap && favouriteCookiesMap.includes(button.dataset.elevation.toLowerCase())) {
                savedElevationsCount = savedElevationsCount + 1;
            }
        }

        // svgator animated button switching + cookie management for favourites
        for (let button of favoriteButtons) {
            //check cookies if an elevation has been favourited & apply visual based on result of above check
            if (favouriteCookiesMap && favouriteCookiesMap.includes(button.dataset.elevation.toLowerCase())) {
                button.dataset.favourite = 'true';
                button.querySelector('.static-icon-heart-filled').classList.remove('hidden');
                button.classList.add('gtm-elevation-unfavourite');
                button.classList.remove('gtm-elevation-favourite');
            } else {
                button.querySelector('.static-icon-heart-depleted').classList.remove('hidden');
                button.classList.add('gtm-elevation-favourite');
                button.classList.remove('gtm-elevation-unfavourite');
            }

            // if elevation is a saved elevation will display on saved elevations panel (on load)
            if (savedElevationsPanel) {
                if (favouriteCookiesMap && favouriteCookiesMap.includes(button.dataset.elevation.toLowerCase())) {
                    button.closest('.elevation-card').classList.remove('hidden');
                }
                if (savedElevationsCount) {
                    savedElevationsPanel.querySelector('.elevations-container').classList.remove('hidden');
                } else {
                    savedElevationsPanel.querySelector('.saved-view-full-range').classList.add('hidden');
                    savedElevationsPanel.querySelector('.saved-h1-text').classList.add('sr-only');
                    savedElevationsPanel.querySelector('.no-saved-elevations-container').classList.remove('hidden');
                }
            }

            let lock = 0;
            button.addEventListener('click', () => {
                const ogAnimationFillClone = ogAnimationFill.cloneNode(true);
                const ogAnimationDepleteClone = ogAnimationDeplete.cloneNode(true);

                if (lock === 0) {
                    lock = 1;

                    if (button.dataset.favourite === 'true') {
                        if (favouriteCookies) {
                            let replacementStrings = [(button.dataset.elevation + ', '), (', ' + button.dataset.elevation), button.dataset.elevation];
                            for(let i=0; i < replacementStrings.length; i++) {
                                favouriteCookies = favouriteCookies.replace(replacementStrings[i], '');
                            }
                            createCookie('favourite_elevations', (favouriteCookies), 365);
                        }

                        button.classList.remove('gtm-elevation-unfavourite');
                        button.classList.add('gtm-elevation-favourite');

                        button.appendChild(ogAnimationDepleteClone);
                        ogAnimationDepleteClone.removeAttribute('id');
                        button.dataset.favourite = 'false';

                        //wait before removing static so clone has time to be gen
                        setTimeout(() => {
                            button.querySelector('.static-icon-heart-filled').classList.add('hidden');
                        }, 100);

                        //show next static before removing clone to hide flash on switch
                        setTimeout(() => {
                            button.querySelector('.static-icon-heart-depleted').classList.remove('hidden');
                        }, 1300);

                        //unlock after animation completes and swap animated clones with static copies
                        setTimeout(() => {
                            lock = 0;
                            ogAnimationDepleteClone.remove();
                        }, 1400);

                    } else {
                        if (favouriteCookies) {
                            favouriteCookies = favouriteCookies + ', ' + button.dataset.elevation;
                            createCookie('favourite_elevations', (favouriteCookies), 365);
                        } else {
                            favouriteCookies = button.dataset.elevation;
                            createCookie('favourite_elevations', favouriteCookies, 365);
                        }

                        button.classList.add('gtm-elevation-unfavourite');
                        button.classList.remove('gtm-elevation-favourite');

                        button.appendChild(ogAnimationFillClone);
                        ogAnimationFillClone.removeAttribute('id');
                        button.dataset.favourite = 'true';

                        //wait before removing static so clone has time to be gen
                        setTimeout(() => {
                            button.querySelector('.static-icon-heart-depleted').classList.add('hidden');
                        }, 100)

                        //show next static before removing clone to hide flash on switch
                        setTimeout(() => {
                            button.querySelector('.static-icon-heart-filled').classList.remove('hidden');
                        }, 1000)

                        //unlock after animation completes and swap animated clones with static copies
                        setTimeout(() => {
                            lock = 0;
                            button.querySelector('.static-icon-heart-filled').classList.remove('hidden');
                            ogAnimationFillClone.remove();
                        }, 1100)
                    }
                }
            });
        }
    }
});